import React, {
    useCallback, useContext, useState, useEffect
} from 'react';
import _ from 'lodash';
import { ViewModelForm, ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import {
    InputField, CheckboxField, DropdownSelectField, IconButton, ModalNextProvider
} from '@jutro/components';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { TranslatorContext } from '@jutro/locale';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { useValidation } from 'gw-portals-validation-react';
import { messages as paymentMessages } from 'gw-capability-policychange-common-react';
import metadata from './CommonUploadPage.metadata.json5';
import './CommonUploadPage.messages';
import styles from './CommonUploadPage.module.scss';
import { messages as commonMessages } from 'gw-platform-translations';


function CommonUploadPage(props) {
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const {
        wizardData, updateWizardData, authHeader, currentStepIndex, changeNextSteps, steps, additionalWizardData, updateAdditionalWizardData
    } = props;
    const { submissionVM, selectedData } = wizardData;
    const { EndorsementService } = useDependencies('EndorsementService');
    const [showLoader, setShowLoader] = useState(false);
    const { SpreadsheetService } = useDependencies('SpreadsheetService');
    const { DocumentService } = useDependencies('DocumentService');
    const [underwritingIssues, setUnderwritingIssues] = useState([]);
    const [errorsAndWarnings, setErrorsAndWarnings] = useState([]);
    const [excelErrorPresent, setExcelErrorPresent] = useState(false);
    const filterUWIssuesInCustomOffering = true;
    const [templateDownloaded, settemplateDownloaded] = useState(false);

    const BLOCKS_QUOTES = ['BlocksQuote', 'BlocksQuoteRelease'];
    const BLOCKS_BIND = 'BlocksBind';
    const NON_BLOCKING = 'NonBlocking';

    const displayErrorModal = useCallback(() => {
        settemplateDownloaded(false);
        ModalNextProvider.showAlert({
            title: commonMessages.genericError,
            message: commonMessages.genericErrorMessage,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    }, []);

    const {
        initialValidation,
        isComponentValid,
        registerComponentValidation
    } = useValidation('CommonUploadPage');

    const isDetailsComponentValid = useCallback(() => {
        return true;
    }, [submissionVM]);

    useEffect(() => {
        registerComponentValidation(isDetailsComponentValid);
    }, [registerComponentValidation, isDetailsComponentValid]);

    const onNext = useCallback(async () => {
        if (additionalWizardData.isFarmLineQuoted && submissionVM.status.value.code !== 'Quoted') {
            submissionVM.value = await EndorsementService.quoteEndorsement(
                [submissionVM.jobID.value],
                authHeader
            );
        }
        return wizardData;
    }, [
        EndorsementService,
        authHeader,
        currentStepIndex,
        changeNextSteps,
        selectedData,
        steps,
        submissionVM,
        wizardData
    ]);

    const handleError = useCallback(
        (title, message) => {
            return ModalNextProvider.showAlert({
                title: title,
                message: message,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
        }, []
    );

    const generateUploadToken = useCallback(async () => {
        const uploadTokenID = await DocumentService.generateUploadToken(authHeader);
        return uploadTokenID;
    }, [DocumentService, authHeader]);

    const onUploadDocument = useCallback(
        async (file) => {
            setShowLoader(true);
            setExcelErrorPresent(false);
            const documentMetaDataTemplate = {
                docUID: '001',
                documentType: 'other',
                securityType: 'unrestricted',
                status: 'approved',
                jobNumber: submissionVM.jobID.value,
                name: file.name,
                mimeType: file.type,
                sessionID: await generateUploadToken()
            };
            try {
                const data = await SpreadsheetService.uploadDocument(
                    file,
                    documentMetaDataTemplate,
                    authHeader
                );
                /*if(data.quoteData && data.quoteData.errorsAndWarnings && data.quoteData.errorsAndWarnings.underwritingIssues){
                    setUnderwritingIssues(data.quoteData.errorsAndWarnings.underwritingIssues);
                }
                if(data.quoteData && data.quoteData.errorsAndWarnings && data.quoteData.errorsAndWarnings.validationIssues && data.quoteData.errorsAndWarnings.validationIssues.issues){
                    setErrorsAndWarnings(data.quoteData.errorsAndWarnings.validationIssues.issues);
                }*/
                submissionVM.value = await EndorsementService.loadEndorsement(
                    submissionVM.policyNumber.value,
                    authHeader
                );
                if (submissionVM.status.value.code === 'Quoted') {
                    updateAdditionalWizardData({isFarmLineQuoted: true});
                }
                setShowLoader(false);
                if (data.fileBase64Data){
                    setExcelErrorPresent(true);
                    const base64EncodedPDF = data.fileBase64Data;
                    const dataURI = 'data:' + data.documentFile.contentType + ';base64,' + base64EncodedPDF;
                    //window.open(dataURI, '_blank');
                    const link = document.createElement('a');
                    link.href = dataURI;
                    link.download = `FarmQuote_${submissionVM.jobID.value}`;
                    link.click();
                } else {
                    setExcelErrorPresent(false);
                    ModalNextProvider.showAlert({
                        title: commonMessages.successMessage,
                        message: commonMessages.successMessageInfo,
                        status: 'info',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).catch(_.noop);
                }
            } catch (error) {
                setShowLoader(false);
                handleError(commonMessages.errorUploadTitle, commonMessages.uploadFailedMessage);
            }
        },
        [submissionVM, generateUploadToken, SpreadsheetService, authHeader, updateWizardData, handleError]
    );

    const downloadQuoteDocument = useCallback(async () => {
        setShowLoader(true);
        await SpreadsheetService
            .downloadSpreadsheetTemplate(submissionVM.jobID.value, authHeader, displayErrorModal);
        setShowLoader(false);
    },
    [submissionVM, authHeader, displayErrorModal, SpreadsheetService]
    );

    const geterrorsAndWarningsTableCell = useCallback(
        (item, index, props) => {
            const path = props.path;
            if (path === 'errorType') {
                const errorType = item.type === 'error' ? 'Error' : 'Warning'
                return (
                    <InputField
                        dataType="string"
                        id={index + path}
                        value={errorType}
                        readOnly={true}
                    />
                );
            } else if (path === 'displayName') {
                return (
                    <InputField
                        dataType="string"
                        id={index + path}
                        value={item.reason}
                        readOnly={true}
                    />
                );
            }
        },
        []
    );

    const findBlockingPoint = (type) => {
        return underwritingIssues.some((offeringIssue) => {
            if (type === BLOCKS_BIND) {
                return offeringIssue.currentBlockingPoint === BLOCKS_BIND;
            }
            return _.includes(BLOCKS_QUOTES, offeringIssue.currentBlockingPoint);
        });
    };

    const overrideProps = {
        '@field': {
            labelPosition: 'left'
        },
        underWritingIssues: {
            underwritingIssues: underwritingIssues,
            blockQuote: findBlockingPoint(),
            quoteID: submissionVM.jobID.value,
            filterUWIssuesInCustomOffering,
            job:submissionVM.baseData.jobType.value
        },
        errorsAndWarningsTable: {
            data: errorsAndWarnings
        },
        errorsAndWarningsTableContainer: {
            visible: errorsAndWarnings.length > 0
        },
        processInlineLoader: {
            loaded: !showLoader,
            loadingMessage: 'Please wait while we upload the document.'
        },
        PackageDetailsUploadPage: {
            visible: !showLoader
        },
    };

    const resolvers = {
        resolveCallbackMap: {
            onUploadDocument: onUploadDocument,
            geterrorsAndWarningsTableCell: geterrorsAndWarningsTableCell,
            downloadQuoteDocument: downloadQuoteDocument
        }
    };

    const isInDraft = () => {
        return submissionVM.status.value.code !== 'Quoted' && additionalWizardData.isFarmLineQuoted !== true;
    };

    return (
        <WizardPage
            onNext={onNext}
            disableNext={isInDraft()}
            skipWhen={initialValidation}
            cancelLabel={translator(appConfig.persona === 'policyholder' ? paymentMessages.cancelAllChanges : paymentMessages.cancel)}
            showPrevious
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={styles}
            />
        </WizardPage>
    );
}

CommonUploadPage.propTypes = wizardProps;
export default withAuthenticationContext(CommonUploadPage);
